// extracted by mini-css-extract-plugin
export default {"ViolationsListSummary":"ViolationsList-module__ViolationsListSummary--BZbzI"};